import React from 'react';
import './ProblemSection.css';

const ProblemSection = () => {
  const problems = [
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
        </svg>
      ),
      title: 'Fragmented Information',
      description: 'Students struggle with scattered information across multiple sources about courses, colleges, exams, and careers.',
      cardBg: 'orange'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
      title: 'Reactive Guidance',
      description: 'Career guidance in most schools begins after results, when choices are limited and decisions become rushed.',
      cardBg: 'navy'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      ),
      title: 'Unverified Sources',
      description: 'Dependence on rumours, pressure, and unverified advice leads to poor decision-making and regret.',
      cardBg: 'orange'
    }
  ];

  return (
    <section className="section problem-section">
      <div className="container">
        <h2 className="section-title">
          <span className="title-navy">The Problem </span>
          <span className="title-orange">We Solve</span>
        </h2>
        <p className="section-subtitle">Career guidance in most schools begins after results, when choices are already limited</p>

        <div className="problem-content">
          <div className="problem-cards">
            {problems.map((problem, index) => (
              <div key={index} className={`problem-card problem-card-${problem.cardBg}`}>
                <div className="problem-icon">
                  {problem.icon}
                </div>
                <div className="problem-text">
                  <h3 className="problem-title">{problem.title}</h3>
                  <p className="problem-description">{problem.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="problem-banner-right">
            <img src="/problem_banner_right.jpeg" alt="Career guidance" className="problem-banner-img" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
